import { fonts } from '~/src/helpers/font';
import { ILandingElement, EElementType } from '~/src/services/projects';

export const Callback: ILandingElement = {
    title: 'Callback',
    type: EElementType.Block,
    label: 'Заказ звонка',
    properties: {
        blockName: '',
        customStyles: '',
        sortOrder: '',
        background: '',
        backgroundWebp: '',
        marginTop: '',
        marginBottom: '',
    },
    children: [
        {
            title: 'Title',
            type: EElementType.RTE,
            label: 'Заголовок',
            properties: {
                customize: {
                    font: fonts.H1,
                    color: '#1A1A1A',
                    textAlign: 'left',
                    tag: '',
                },
                htmlContent: 'Заголовок',
                customStyles: 'white-space: pre-wrap;',
            },
        },
        {
            title: 'SubTitle',
            type: EElementType.RTE,
            label: 'Подзаголовок',
            properties: {
                customize: {
                    font: fonts.L,
                    color: '#1A1A1A',
                    textAlign: 'left',
                    tag: '',
                },
                htmlContent: 'Подзаголовок',
                customStyles: '',
            },
        },
        {
            title: 'PhoneForm',
            type: EElementType.PhoneForm,
            label: 'Форма',
            properties: {
                customize: {
                    globalEnsId: '',
                },
                phonePlaceholder: 'Номер телефона',
                buttonText: 'Подключить',
                customStyles: '',
            },
            children: [{
                title: 'Button',
                type: EElementType.Button,
                label: 'Кнопка',
                properties: {
                    customStyles: '',
                    isTargetBlank: false,
                },
                children: [
                    {
                        title: 'Text',
                        type: EElementType.Text,
                        label: 'Текст',
                        properties: {
                            customize: {
                                font: fonts.Medium,
                                color: '#FFF',
                                href: '',
                            },
                            content: 'Подключить',
                            customStyles: '',
                        },
                    },
                ],
            }],
        },
        {
            title: 'Instruction',
            type: EElementType.TextWithoutContent,
            label: 'Инструкция',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#1A1A1A',
                    textAlign: 'left',
                },
            },
            children: [
                {
                    title: 'Step1',
                    type: EElementType.RTE,
                    label: 'Шаг1',
                    properties: {
                        htmlContent: 'Уточним детали',
                    },
                },
                {
                    title: 'Step2',
                    type: EElementType.RTE,
                    label: 'Шаг2',
                    properties: {
                        htmlContent: 'Согласуем время визита техника',
                    },
                },
                {
                    title: 'Step3',
                    type: EElementType.RTE,
                    label: 'Шаг3',
                    properties: {
                        htmlContent: 'Техник проведёт интернет и оформит договор',
                    },
                },
            ],
        },
        {
            title: 'Phone',
            type: EElementType.TextWithoutContent,
            label: 'Телефон',
            properties: {
                customize: {
                    font: fonts.L,
                    color: '#1A1A1A',
                    textAlign: 'left',
                },
                customStyles: '',
            },
        },
    ],
};
